import { exists } from '@/api'
import { ReminderMailBatchType } from '@/utils'

export interface SearchReminderMailRequest {
  dueDateFrom: string
  dueDateTo: string
  branchCodeFrom: string
  branchCodeTo: string
  branchType: ReminderMailBranchType
  hasReservationOnly: boolean
  batchType: string
}

export const ReminderMailBranchType = {
  UserRegistrationBranch: '1',
  lendBranch: '2',
  holdingBranch: '3'
} as const
export type ReminderMailBranchType = typeof ReminderMailBranchType[keyof typeof ReminderMailBranchType]

// リクエストと連動しているのでこちらに記述
export function SearchReminderMailRequestFromJSON(
  json: any
): SearchReminderMailRequest {
  return {
    dueDateFrom: exists(json, 'due_date_from') ? json.due_date_from : '',
    dueDateTo: exists(json, 'due_date_to') ? json.due_date_to : '',
    branchCodeFrom: exists(json, 'branch_code_from')
      ? json.branch_code_from
      : '',
    branchCodeTo: exists(json, 'branch_code_to') ? json.branch_code_to : '',
    branchType: exists(json, 'branch_type')
      ? json.branch_type
      : ReminderMailBranchType.UserRegistrationBranch,
    hasReservationOnly: exists(json, 'has_reservation_only')
      ? JSON.parse(json.has_reservation_only)
      : false,
    batchType: ReminderMailBatchType
  }
}

export function SearchReminderMailRequestToJSON(
  value: SearchReminderMailRequest
): any {
  return {
    due_date_from: value.dueDateFrom !== '' ? value.dueDateFrom : undefined,
    due_date_to: value.dueDateTo !== '' ? value.dueDateTo : undefined,
    branch_code_from:
      value.branchCodeFrom !== '' ? value.branchCodeFrom : undefined,
    branch_code_to: value.branchCodeTo !== '' ? value.branchCodeTo : undefined,
    branch_type:
      value.branchType !== ReminderMailBranchType.UserRegistrationBranch
        ? value.branchType
        : undefined,
    has_reservation_only: value.hasReservationOnly ?? undefined,
    batch_type: value.batchType !== '' ? value.batchType : undefined
  }
}
